import { useMutation, useQuery } from '@tanstack/react-query';
import { EditIcon } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';

import { DialogDeleteRecordConfirmation } from '../../../../components/pages/backoffice/dialogs/delete-record.jsx';
import DecorativeInput from '../../../../components/decorative-input.jsx';
import Error from '../../../../components/feedback/error.jsx';
import Loading from '../../../../components/feedback/loading.jsx';
import Heading from '../../../../components/typography/heading.jsx';
import { Button } from '../../../../components/ui/button.jsx';
import { Checkbox } from '../../../../components/ui/checkbox.jsx';
import FormCard from '../../../../components/ui/form-card.jsx';
import FormFooter from '../../../../components/ui/form-footer.jsx';
import { msCatalystApi } from '../../../../services/api/ms-catalyst-api.js';
import { CATALYST_USER_ROLES } from '../../../../utils/constants.js';

export function StaffShow() {
  let { staffId } = useParams();

  const queryStaff = useQuery({
    queryKey: ['user'],
    queryFn: async () => {
      const { data: staff } = await msCatalystApi.get(`/staff/${staffId}`);

      return staff.data;
    },
  });

  const mutationDeleteBackofficeUser = useMutation({
    mutationFn: async (data) => {
      await msCatalystApi.delete(`/staff/${data.staffId}`);
      await msCatalystApi.delete(`/users/${data.userId}`);
    },
  });

  if (queryStaff.isLoading) {
    return <Loading />;
  }

  if (queryStaff.isError) {
    return <Error />;
  }

  return (
    <>
      <div className="pb-6">
        <Heading className="pb-2">Utilizador</Heading>
        <h2 className="text-lg text-zinc-600 dark:text-zinc-400">
          {queryStaff.data.firstName} {queryStaff.data.lastName}
        </h2>
      </div>

      <div className="flex flex-col space-y-10">
        {/* START - DADOS GERAIS - START */}
        <div className="flex flex-col gap-5">
          <FormCard className="grid grid-cols-1 gap-6 rounded-lg bg-zinc-100 p-10 dark:bg-zinc-900 lg:grid-cols-2">
            <DecorativeInput value={queryStaff.data.firstName} label="Nome" />

            <DecorativeInput value={queryStaff.data.lastName} label="Apelido" />

            <DecorativeInput value={queryStaff.data.email} label="Email" />

            <DecorativeInput
              value={Object.values(CATALYST_USER_ROLES).find(
                (role) => role === queryStaff.data.role,
              )}
              label="Função"
            />

            <div>
              <p className="mb-3 inline-block">Estado</p>
              <div className="flex h-10 flex-row items-center space-x-2">
                <Checkbox
                  disabled={true}
                  id="ongoing"
                  checked={queryStaff.data.status}
                />
                <span className="space-y-0 text-sm">Ativo</span>
              </div>
            </div>
          </FormCard>
        </div>
        {/* END - DADOS GERAIS - END */}
      </div>

      <FormFooter>
        <DialogDeleteRecordConfirmation
          action={async () => {
            await mutationDeleteBackofficeUser.mutateAsync({
              staffId,
              userId: queryStaff.data.userId,
            });
          }}
          redirect="/backoffice/admin/staff"
          recordName={`${queryStaff.data.firstName} ${queryStaff.data.lastName}`}
        />

        <Button asChild>
          <Link to={`/backoffice/admin/staff/${staffId}/edit`}>
            <EditIcon />
            Editar
          </Link>
        </Button>
      </FormFooter>
    </>
  );
}
